module.exports = __webpack_public_path__ + "img/ht.9012459f.svg";